import keyMirror from '@kopapro-redux/utils/key-mirror';

// misc action type
export default keyMirror({
  PREVIEW_SHOP_SETUP: null,
  PREVIEW_SHOP_LAYOUT: null,
  PREVIEW_SHOP_COMPONENT_SETTING: null,
  PREVIEW_SHOP_BANNERS: null,
});
